import React from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-styled-flexboxgrid'
import styled from 'styled-components'

import Text from 'components/Atoms/Text'
import Image from 'components/Atoms/Image'
import { withTranslation } from 'i18n-web/i18next'

const Component = styled(Row)`
  justify-content: center;
  text-align: center;
  flex-direction: column;
  align-items: center;
`

const EmailIcon = styled(Image)`
  margin-bottom: 20px;
`

const Description = styled(Text)`
  margin-top: 10px;
  margin-bottom: 20px;
`

const DownloadApp = styled(Text)`
  margin-left: 5px;
  margin-right: 5px;
  &:hover {
    opacity: 0.7;
  }
`

const EmailVerified = ({ t }) => (
  <Component>
    <Col xs={12} sm={12}>
      <EmailIcon width="170" src={'/static/images/verify_your_email.png'} />
      <Text className="center h3 normal" as="h1">
        {t('signUp.emailVerified.content.title')}
      </Text>
    </Col>
    <Col xs={12} sm={5}>
      <Description className="center medium spacing">
        {t('signUp.emailVerified.content.description')}
      </Description>
    </Col>
    <Col xs={12} sm={5}>
      <DownloadApp
        as="a"
        target="_blank"
        href="https://itunes.apple.com/us/app/citifyd/id984113093?ls=1&mt=8">
        <Image
          alt="App Store badge"
          width="150"
          src={'/static/images/app_store_badge.png'}
        />
      </DownloadApp>
      <DownloadApp
        as="a"
        target="_blank"
        href="https://play.google.com/store/apps/details?id=com.citifyd.Citifyd">
        <Image
          alt="Google Play badge"
          width="150"
          src={'/static/images/google_play_badge.png'}
        />
      </DownloadApp>
    </Col>
  </Component>
)

EmailVerified.propTypes = {
  t: PropTypes.func,
}

export default withTranslation()(EmailVerified)
